import './laziza/style';
import FormStructure from './laziza/form_structure';

export default FormStructure;